import { CalendarCheck, CalendarRange, Wallet, Truck, Users, Handshake, BarChart3, Building2 } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

export const modules = [
  { icon: CalendarCheck, title: "Réservations", desc: "Centralisez vos réservations, clients, participants, formules, options, réductions et paiements.", span: "lg:col-span-2" },
  { icon: CalendarRange, title: "Planning", desc: "Visualisez votre journée ou votre semaine et affectez véhicules et équipes.", span: "" },
  { icon: Wallet, title: "Caisse & dépenses", desc: "Suivez les encaissements, mouvements de caisse, dépenses et justificatifs.", span: "" },
  { icon: Truck, title: "Flotte", desc: "Gérez véhicules, disponibilité, maintenance et incidents.", span: "" },
  { icon: Users, title: "Équipe", desc: "Organisez guides, chauffeurs, réception et collaborateurs.", span: "" },
  { icon: Handshake, title: "Partenaires", desc: "Suivez hôtels, riads, agences, guides partenaires et leurs commissions.", span: "" },
  { icon: BarChart3, title: "Statistiques", desc: "CA encaissé, réservations, dépenses, résultat estimé, participants et performances.", span: "" },
  { icon: Building2, title: "Multi-sites", desc: "Gérez plusieurs établissements depuis une seule organisation et passez instantanément d'un site à l'autre.", span: "lg:col-span-2" },
];

const FeaturesGrid = () => (
  <section data-testid="features-section" id="fonctionnalites" className="scroll-mt-24 bg-white py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow index="02">Fonctionnalités</Eyebrow>
        <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
          Tout votre pilotage, dans une seule interface.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-navy/60 sm:text-lg">
          Huit modules pensés pour l'exploitation réelle des activités touristiques et de loisirs.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {modules.map((m, i) => (
          <Reveal key={m.title} delay={0.05 * i} className={m.span}>
            <div data-testid={`feature-card-${m.title.toLowerCase().replace(/[^a-z]/g, "-")}`} className="group h-full rounded-2xl border border-slate-200 bg-mist/40 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-brand/25 hover:bg-white hover:shadow-lift sm:p-6">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand/10 text-brand transition-colors duration-300 group-hover:bg-brand group-hover:text-white sm:h-11 sm:w-11">
                <m.icon className="h-5 w-5" />
              </span>
              <h3 className="mt-3 text-lg font-semibold text-navy sm:mt-4">{m.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-navy/60 sm:mt-2">{m.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesGrid;
